export const initVideoMute = () => {
  const videoContainer = document.querySelector(".landing-hero");
  if (!videoContainer) return;

  const video = videoContainer.querySelector("video");
  const soundButton = videoContainer.querySelector(".landing-hero__sound");
  const slashLine = soundButton?.querySelector("line");

  if (!video || !soundButton || !slashLine) return;

  // Set initial state
  updateSoundIcon(video.muted, slashLine);

  // Toggle mute/unmute on button click
  soundButton.addEventListener("click", () => {
    video.muted = !video.muted;
    updateSoundIcon(video.muted, slashLine);
  });

  // Update icon if video is muted by other means
  video.addEventListener("volumechange", () => {
    updateSoundIcon(video.muted, slashLine);
  });
};

function updateSoundIcon(isMuted, slashLine) {
  if (isMuted) {
    // Show slash line when muted
    if (slashLine) slashLine.style.display = "block";
  } else {
    // Hide slash line when unmuted
    if (slashLine) slashLine.style.display = "none";
  }
}
